
export default function () {

  return {
    query: '',
  };
}
